import { Genders } from '@/utils/enums';

export const GENDERS = [
  { label: 'Мужской', value: Genders.MALE },
  { label: 'Женский', value: Genders.FEMALE },
];
